module.exports = __webpack_public_path__ + "static/fabric-table-highlight-0c94dddb8f8bf837dada17c5e42fcaaa.png";